<av-card [backdrop]="false">
  <av-card-header
    subtitle="Share this URL with the customer to start an AI support session."
    (close)="dismiss.emit()"
  >
    {{ "AI Assistant" | translate }}
  </av-card-header>
  <av-card-body type="spotlight" size="sm">
    <av-spinner *ngIf="isLoading()" mode="dark" size="md"></av-spinner>
    <span *ngIf="!isLoading()">{{ ticketURL() }}</span>
  </av-card-body>
  <av-card-footer class="fx-column fx-gap-sm">
    <!-- <input
      type="text"
      avInput
      placeholder="Customer's name"
      [ngModel]="customerName()"
      (ngModelChange)="customerNameChange($event)"
    /> -->
    <button
      avButton
      color="accent"
      ofType="flat"
      size="block"
      data-tid="ai-assistant/copy-url"
      (click)="copy()"
    >
      Copy
    </button>
  </av-card-footer>
</av-card>
